// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {putMachineStatusUpdates} from '../repositories';
import {readMachineStatusUpdates} from './get-machine-status-updates';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

const buildDeleteMachineUpdatePayload = machineUpdate => ({
    ...machineUpdate,
    status: 'DELETED'
});

export const deleteMachineStatus = (machineUpdate, selectedDealer) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putMachineStatusUpdates(buildDeleteMachineUpdatePayload(machineUpdate));

            dispatch(readMachineStatusUpdates(selectedDealer));

            successAlertBar(translate('DELETE_MACHINE_STATUS_UPDATE_SUCCESS'));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/machine-status-update/action-creators/delete-machine-update.js